import React, {Component} from 'react';
import Node from './Node/Node'
import {dijkstra, getNodesInShortestPathOrder} from './Algorithms/dijkstra';
import {dfs,getNodeInPath} from './Algorithms/dfs';
import {bfs,getNodesInShortestPathOrder1} from './Algorithms/bfs'
import {Link} from 'react-router-dom'
import styles from '../Mainpage/Mainpage.module.css'
import './Pathfinding.css'


//Source node and destination node coordinates
var START_NODE_ROW = 8;
var START_NODE_COL = 15;
var FINISH_NODE_ROW = 8;
var FINISH_NODE_COL = 35;

var Disable = false;

//main component
export default class Pathfinding extends Component {
  //state of our component
  constructor() {
    super();
    this.state = {
      grid: [],
      mouseIsPressed: false,
      source: false,
      destination:false,
      address:'/'
    };
  }
  
  //Lifecycle method which initiate object before content loading
  componentDidMount() {
    const grid = getInitialGrid();
    this.setState({grid});
  }

  handleMouseDown(row, col) {
    
    if(row === START_NODE_ROW && col === START_NODE_COL){
      this.state.source = true;
    }
    else if(row === FINISH_NODE_ROW && col === FINISH_NODE_COL){
      this.state.destination = true;
    }
    else{
    const newGrid = getNewGridWithWallToggled(this.state.grid, row, col);
    this.setState({grid: newGrid, mouseIsPressed: true});
    }

  }

  handleMouseEnter(row, col) {
    
    if(this.state.source){
      const newGrid1 = getNewGridWithToggledSource(this.state.grid,START_NODE_ROW,START_NODE_COL);
      this.setState({grid:newGrid1});
      START_NODE_COL = col;
      START_NODE_ROW = row;
      const newGrid = getNewGridWithToggledSource(this.state.grid,row,col);
      this.setState({grid:newGrid});
    }
    else if(this.state.destination){
      const newGrid1 = getNewGridWithToggledDestination(this.state.grid,FINISH_NODE_ROW,FINISH_NODE_COL);
      this.setState({grid:newGrid1});
      FINISH_NODE_COL = col;
      FINISH_NODE_ROW = row;
      const newGrid = getNewGridWithToggledDestination(this.state.grid,row,col);
      this.setState({grid:newGrid});
    }
    else{
    if (!this.state.mouseIsPressed) return;
    const newGrid = getNewGridWithWallToggled(this.state.grid, row, col);
    this.setState({grid: newGrid});
    }
  }

  handleMouseUp() {
    this.setState({
      mouseIsPressed: false,
      source:false,
      destination:false
    });
  }
  

  resetBoard(){
   if(Disable === false){
    const board = this.state.grid;
        START_NODE_ROW = 8;
        START_NODE_COL = 15;
        FINISH_NODE_ROW = 8;
        FINISH_NODE_COL = 35;
    for(let row = 0;row<17;row++){
      for(let col = 0;col<50;col++){
        const node = board[row][col];
        document.getElementById(`node-${node.row}-${node.col}`).className = 'node';
        node.col=col;
        node.row=row;
        node.isStart =  row === START_NODE_ROW && col === START_NODE_COL;
        node.isFinish = row === FINISH_NODE_ROW && col === FINISH_NODE_COL;
        node.distance = Infinity;
        node.isVisited = false;
        node.isWall = false;
        node.previousNode = null;

      }
    }
    const sNode = board[START_NODE_ROW][START_NODE_COL];
    const fNode = board[FINISH_NODE_ROW][FINISH_NODE_COL];
    document.getElementById(`node-${sNode.row}-${sNode.col}`).className = 'node node-start';
    document.getElementById(`node-${fNode.row}-${fNode.col}`).className = 'node node-finish';
    this.setState({grid:board})
  }
  }

  animateDijkstra(visitedNodesInOrder, nodesInShortestPathOrder) {

    if(Disable === false){
      Disable = true;
      this.setState({address:'/pathfind'});
    for (let i = 0; i <= visitedNodesInOrder.length; i++) {
      if (i === visitedNodesInOrder.length) {
        setTimeout(() => {
          this.animateShortestPath(nodesInShortestPathOrder);
        }, 10 * i);
        
        setTimeout(()=>{
          Disable = false;
          this.setState({address:'/'});
        },10*i);
        
        return;
      }
      setTimeout(() => {
        const node = visitedNodesInOrder[i];
        document.getElementById(`node-${node.row}-${node.col}`).className =
          'node node-visited';
      }, 10 * i);
      
    }
  }
  
  }

  animateShortestPath(nodesInShortestPathOrder) {
    for (let i = 0; i < nodesInShortestPathOrder.length; i++) {
      setTimeout(() => {
        const node = nodesInShortestPathOrder[i];
        document.getElementById(`node-${node.row}-${node.col}`).className =
          'node node-shortest-path';
      }, 50 * i);
    }
  }

  visualizeDijkstra() {
    var t0 = performance.now();
    const {grid} = this.state;
    const startNode = grid[START_NODE_ROW][START_NODE_COL];
    const finishNode = grid[FINISH_NODE_ROW][FINISH_NODE_COL];
    const visitedNodesInOrder = dijkstra(grid, startNode, finishNode);
    const nodesInShortestPathOrder = getNodesInShortestPathOrder(finishNode);
    this.animateDijkstra(visitedNodesInOrder, nodesInShortestPathOrder);
    var t1 = performance.now();
    console.log(t1-t0);
  }

  visualizeDfs(){
    const {grid} = this.state;
    const startNode = grid[START_NODE_ROW][START_NODE_COL];
    const finishNode = grid[FINISH_NODE_ROW][FINISH_NODE_COL];
    const visitedNodesInOrder = dfs(grid, startNode, finishNode);
    const nodeInPath = getNodeInPath();
    this.animateDijkstra(visitedNodesInOrder,nodeInPath);
  }

  visualizeBfs(){
    const {grid} = this.state;
    const startNode = grid[START_NODE_ROW][START_NODE_COL];
    const finishNode = grid[FINISH_NODE_ROW][FINISH_NODE_COL];
    const visitedNodesInOrder = bfs(grid, startNode, finishNode);
    const nodesInShortestPathOrder = getNodesInShortestPathOrder1(finishNode);
    this.animateDijkstra(visitedNodesInOrder,nodesInShortestPathOrder);

  }

  render() {
    const {grid, mouseIsPressed} = this.state;

    return (
      <>
        <div className="navbar-fixed">
        <nav className="nav-wrapper white">
            <div className="container">
            <Link to={this.state.address} className="brand-logo" className={styles.logo}><img src='/img/image.tj9vk9'  alt='logo' /></Link>
                <ul className = "right">
                <li><a className = "black-text" onClick={() => this.visualizeBfs()}>Breadth-first Search</a></li>
                <li><a className = "black-text" onClick={() => this.visualizeDfs()}>Depth-first Search</a></li>
                <li><a className = "black-text" onClick={() => this.visualizeDijkstra()}>Dijkstra's Algorithm</a></li>
                <li><a className = "black-text" onClick={()=>this.resetBoard()}>RESET</a></li>
                </ul>
            </div>
        </nav>
        </div>
        
        <div className="grid">
          {grid.map((row, rowIdx) => {
            return (
              <div key={rowIdx}>
                {row.map((node, nodeIdx) => {
                  const {row, col, isFinish, isStart, isWall} = node;
                  return (
                    <Node
                      key={nodeIdx}
                      col={col}
                      isFinish={isFinish}
                      isStart={isStart}
                      isWall={isWall}
                      mouseIsPressed={mouseIsPressed}
                      onMouseDown={(row, col) => this.handleMouseDown(row, col)}
                      onMouseEnter={(row, col) =>
                        this.handleMouseEnter(row, col)
                      }
                      onMouseUp={() => this.handleMouseUp()}
                      row={row}></Node>
                  );
                })}
              </div>
            );
          })}
        </div>
      </>
    );
  }
}

const getInitialGrid = () => {
  const grid = [];
  for (let row = 0; row < 17; row++) {
    const currentRow = [];
    for (let col = 0; col < 50; col++) {
      currentRow.push(createNode(col, row));
    }
    grid.push(currentRow);
  }
  return grid;
};

const createNode = (col, row) => {
  return {
    col,
    row,
    isStart: row === START_NODE_ROW && col === START_NODE_COL,
    isFinish: row === FINISH_NODE_ROW && col === FINISH_NODE_COL,
    distance: Infinity,
    isVisited: false,
    isWall: false,
    previousNode: null,
  };
};

const getNewGridWithWallToggled = (grid, row, col) => {
  const newGrid = grid.slice();
  const node = newGrid[row][col];
  const newNode = {
    ...node,
    isWall: !node.isWall,
  };
  newGrid[row][col] = newNode;
  return newGrid;
};

const getNewGridWithToggledSource = (grid,row,col) =>{
  const newGrid = grid.slice();
  const node = newGrid[row][col];
  const newNode = {
    ...node,
    isStart: !node.isStart,
  };
  newGrid[row][col] = newNode;
  return newGrid;
} 

const getNewGridWithToggledDestination = (grid,row,col) =>{
  const newGrid = grid.slice();
  const node = newGrid[row][col];
  const newNode = {
    ...node,
    isFinish: !node.isFinish,
  };
  newGrid[row][col] = newNode;
  return newGrid;
}